// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".follow-tag__icon[data-v-79e6c214] .a-icon__description{color:#000}", ""]);
// Exports
module.exports = exports;
